import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListWaitingMovementExecutionsInput } from "@nexxt/contracts/logistics";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";
import { stockMovementQueries } from "../stock-movement/stock-movement.queries";

// Server state of the executions of the warehouse Nexxt could not apply (I-11 §5, ADR-142): under the keys of the
// movements, since applying one changes a movement, and a write on a movement reloads them.

const waiting = api.logistics["waiting-movement-executions"];

export type WaitingExecution = InferResponseType<typeof waiting.$get, 200>["items"][number];

/** The filters of the list input (`listWaitingMovementExecutionsInput`), without the paging the queries add. */
export type WaitingExecutionFilters = Pick<ListWaitingMovementExecutionsInput, "reason">;

const PAGE_SIZE = 50;

const keys = {
  /** Prefix of every cached list of the executions that wait. */
  waiting: [...stockMovementQueries.all, "waiting-executions"] as const,
};

export const movementExecutionQueries = {
  ...keys,

  waiting: (filters: WaitingExecutionFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.waiting, filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          waiting.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
